import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { LoginRegisterService } from '../login-register/login-register.service';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {

  slideConfig = {
    slidesToShow: 3.75,
    slidesToScroll: 1,
    infinite: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3.5,
          slidesToScroll: 1,
          infinite: false
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  totalArticles: any[] = [];
  howItWorksSteps = [
    {
      heading: 'CHOOSE ROLE',
      subHeading: 'Select the position you’re hiring for.',
      number: '01',
      role: 'MANAGER',
      icon: 'step1.png'
    },
    {
      heading: 'SET SKILLS & DIFFICULTY',
      subHeading: 'Pick skills, difficulty, duration and balance the test.',
      number: '02',
      role: 'MANAGER',
      icon: 'step2.png'
    },
    {
      heading: 'ADD AI INSTRUCTIONS',
      subHeading: 'Guide how questions are generated to match your hiring style.',
      number: '03',
      role: 'MANAGER',
      icon: 'step3.png'
    },
    {
      heading: 'GENERATE QUESTIONS',
      subHeading: 'Create a tailored assessment in minutes.',
      number: '04',
      role: 'MANAGER',
      icon: 'step4.png'
    },
    {
      heading: 'SHARE TEST LINK',
      subHeading: 'Publish and send via email, ATS, or WhatsApp.',
      number: '05',
      role: 'HR',
      icon: 'step5.png'
    },
    {
      heading: 'SHORTLIST BY SKILLS',
      subHeading: 'See skill-wise performance and rank top performers.',
      number: '06',
      role: 'MANAGER',
      icon: 'step4.png'
    },
    {
      heading: 'HIRE BETTER',
      subHeading: 'Make confident decisions based on real capability.',
      number: '07',
      role: 'TEAM',
      icon: 'step5.png'
    }
  ];

  private readonly romanMap = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX', 'X'];

  howItWorksDetailedSteps = [
    {
      index: 0,
      title: 'Choose the Role',
      icon: 'manage_accounts',
      intro: 'Start by selecting the role you’re hiring for - tech, sales, operations, support, marketing, or anything else.',
      groups: [
        { label: 'What happens:', items: ['Evaltrix understands the skill requirements', 'Auto-suggests core skill areas', 'Loads ready-to-use templates', 'You focus on the role. Evaltrix handles the structure.'] }
      ]
    },
    {
      index: 1,
      title: 'Set Skills & Difficulty',
      icon: 'tune',
      intro: 'Pick the skills you want to evaluate and adjust difficulty levels (Easy, Medium, Hard).',
      groups: [
        { label: 'You can:', items: ['Add multiple skills', 'Mix difficulty levels', 'Customize test duration', 'Combine technical & non-technical skills'] },
        { label: '', items: ['Create a smart, balanced assessment in seconds.'] }
      ]
    },
    {
      index: 2,
      title: 'Add Custom AI Instructions',
      icon: 'smart_toy',
      intro: 'Tell the AI exactly how your questions should be generated.',
      groups: [
        { label: 'Define:', items: ['Tone and depth', 'Real-world context', 'What to include or avoid', 'Complexity based on seniority'] },
        { label: '', items: ['Your instructions → Your questions → Your hiring style.'] }
      ]
    },
    {
      index: 3,
      title: 'Generate Questions Instantly',
      icon: 'auto_awesome',
      intro: 'Click generate - and Evaltrix builds a full assessment tailored to your role.',
      groups: [
        { label: 'You get:', items: ['Custom, fresh questions', 'Scenario-based items', 'Unlimited variants', 'No repeated patterns'] },
        { label: '', items: ['Your assessment is ready in minutes.'] }
      ]
    },
    {
      index: 4,
      title: 'Publish & Share with One Click',
      icon: 'ios_share',
      intro: 'Share your assessment link via email, ATS, job portal, WhatsApp, or directly with applicants.',
      groups: [
        { label: 'Includes:', items: ['Shareable public link', 'Mobile-friendly test UI', 'No candidate login required'] },
        { label: '', items: ['Faster distribution. Higher completion rates.'] }
      ]
    },
    {
      index: 5,
      title: 'Review Performance & Shortlist by Skills',
      icon: 'insights',
      intro: 'See each candidate’s performance on the skills you selected.',
      groups: [
        { label: 'You get:', items: ['Skill-wise performance', 'Clear ranking of top performers', 'Bias-free, skill-first shortlisting', 'Quick decision-making'] },
        { label: '', items: ['Find the right candidates - fast.'] }
      ]
    },
    {
      index: 6,
      title: 'Hire with Confidence',
      icon: 'verified_user',
      intro: 'Your final hiring decisions are backed by real capability, not assumptions.',
      groups: [
        { label: 'Outcome:', items: ['Better hires', 'Faster hiring cycles', 'Lower cost per hire', 'Stronger teams'] },
        { label: '', items: ['Smarter hiring starts here.'] }
      ]
    }
  ];
  hoverIndex: number = 0;
  showShortDesciption = true;
  feature = [
    {
      heading: 'Interview only the right candidates.',
      points: ['Use online assessment to test on-job-skills.',
        'Evaluate applicants online and shortlist only the right candidates.',
        'Save up on your time and cost in Hiring.'],
      className: 'first-image'
    },
    {
      heading: 'Assess the skills that matters to you most.',
      points: ['Required job skills differ from a company to another company even the job role is the same.',
        'Don’t evaluate your applicants based on readymade problems available on Internet.',
        'Create your own assessment to test on-job-skills.'],
      className: 'second-image'
    }
  ];

  // Facts content aligned with Figma
  factsDetailed: Array<{ title: string; text: string; icon: string }> = [
    {
      title: 'Misleading Resumes',
      text:
        '78% of resumes contain misleading statements or exaggerated qualifications that don’t reflect actual capabilities.',
      icon: 'article'
    },
    {
      title: 'AI‑Written Resumes',
      text:
        'Over 60% of job applications now use AI‑generated content, making it harder to assess genuine writing and communication skills.',
      icon: 'smart_toy'
    },
    {
      title: 'Hidden Talent Overlooked',
      text:
        'Great candidates with non‑traditional backgrounds are filtered out by keyword‑based systems before human review.',
      icon: 'visibility_off'
    },
    {
      title: 'Only 10% Qualified',
      text:
        'Despite hundreds of applications, fewer than 10% of candidates actually meet the basic job requirements.',
      icon: 'verified_user'
    },
    {
      title: 'Shortlisting Takes Weeks',
      text:
        'Recruiters spend an average of 3–4 weeks manually reviewing applications to create a shortlist of viable candidates.',
      icon: 'schedule'
    },
    {
      title: 'Skills Gap',
      text:
        '42% of employers report that candidates lack the technical skills required, even when their resumes suggest otherwise.',
      icon: 'psychology'
    },
    {
      title: 'Recruiter Tool Limitations',
      text:
        'Most ATS systems focus on keywords rather than actual competency, creating false positives and negatives.',
      icon: 'tune'
    },
    {
      title: 'Tech Team Time Loss',
      text:
        'Senior engineers lose 8–12 hours per hire conducting interviews and technical assessments, impacting product development.',
      icon: 'engineering'
    },
    {
      title: 'Reused Questions Enable Cheating',
      text:
        'Common interview questions are widely shared online, allowing candidates to prepare rehearsed answers rather than demonstrate real skills.',
      icon: 'content_copy'
    },
    {
      title: 'Bad Hires Cost 30%',
      text:
        'A poor hiring decision costs companies an average of 30% of the employee’s first‑year salary in lost productivity and rehiring.',
      icon: 'attach_money'
    }
  ];

  factsShort: string[] = [
    'Most resumes show confidence, not competence.',
    'AI-written resumes hide real skills.',
    'Only 1 in 10 applicants are actually qualified.',
    'Your team spends hours building assessments - and candidates still cheat.',
    'Skills matter more than resumes, but companies still filter by CV.',
    'Repeating questions makes hiring predictable.',
    'Bad hires are expensive - skill-based hiring prevents them.'
  ];

  customers = [
    {
      name: 'Cliniceo',
      logo: 'customerlogo1.png'
    },
    {
      name: 'TopTraits AI',
      logo: 'customerlogo2.png'
    }
  ];

  featuresShort = [
    { icon: 'auto_awesome', label: 'AI Question Generator' },          // 0
    { icon: 'tune', label: 'Custom AI Controls' },                     // 1
    { icon: 'speed', label: 'Fast Assessment Builder' },               // 2 (moved up)
    { icon: 'dashboard_customize', label: 'Fully Customizable Tests' },// 3
    { icon: 'signal_cellular_alt', label: 'Difficulty Levels' },       // 4
    { icon: 'shuffle', label: 'Assessment Variants' },                 // 5
    { icon: 'how_to_reg', label: 'Skills-Based Shortlisting' },        // 6
    { icon: 'policy', label: 'Cheating Prevention' },                  // 7
    { icon: 'savings', label: '10x More Affordable' },                 // 8
    { icon: 'diversity_3', label: 'Scalable for All Teams' }           // 9
  ];

  constructor(
    private router: Router,
    private loginRegisterService: LoginRegisterService,
    private homeService: HomeService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.loginRegisterService.currentUser.subscribe((res) => {
      if (res) {
        this.router.navigateByUrl('/dashboard/home');
      }
    });

    this.getHomePageArticles();

    // initialize expanded state for How It Works steps (collapsed by default on mobile)
    // no expand/collapse; all content visible
  }

  // arrows/rail connectors removed

  private getHomePageArticles(): void {
    this.homeService.getHomePageArticles().subscribe((res) => {
      this.totalArticles = res.data;
    }, (error) => {
      // Handle error silently or show user-friendly message
    })
  }

  gotoLogin() {
    this.router.navigate(['/login/employerLogin'], { queryParams: { signupView: true } });
  }

  bookDemo(): void {
    this.router.navigate(['/demo']);
  }

  alterDescriptionText() {
    this.showShortDesciption = !this.showShortDesciption;
  }

  calculateDiff(Odate: any): number {
    let date = new Date(Odate);
    let currentDate = new Date();
    let days = Math.floor((currentDate.getTime() - date.getTime()) / 1000 / 60 / 60 / 24);
    return days;
  }

  gotoHelp(article): void {
    window.open(`https://help.evaltrix.com/product/article/${article.attributes.slug}`, '_blank');
  }

  getExcerpt(article: any): string {
    if (!article || !article.attributes) {
      return '';
    }
    const attrs = article.attributes as any;
    const src: unknown =
      attrs.excerpt ?? attrs.description ?? attrs.summary ?? attrs.content ?? attrs.body ?? '';
    const raw = typeof src === 'string' ? src : '';
    const text = this.stripTags(raw).trim();
    if (!text) {
      // Fallback: derive a friendly one‑liner from title
      const t = (attrs.title as string) || '';
      if (!t) return '';
      const fallback = `Quick guide: ${t}`;
      return fallback.length > 100 ? `${fallback.slice(0, 100).replace(/\s+\S*$/, '')}…` : fallback;
    }
    const max = 140;
    if (text.length <= max) return text;
    const clipped = text.slice(0, max).replace(/\s+\S*$/, '');
    return `${clipped}…`;
  }

  private stripTags(html: string): string {
    // Remove resource-loading tags to prevent network requests (and 404s) when parsing HTML
    const cleanHtml = html.replace(/<(img|script|iframe|link|video|audio|source|track|embed|object)[^>]*>/gi, '');
    const div = document.createElement('div');
    div.innerHTML = cleanHtml;
    return (div.textContent || div.innerText || '').replace(/\s+/g, ' ').trim();
  }

  getReadTime(article: any): string {
    if (!article || !article.attributes) return '2 min read.';
    const attrs = article.attributes as any;
    // Prefer provided reading time if available
    const provided = (attrs.reading_time || attrs.readTime || attrs.read_time) as string | number | undefined;
    if (provided) {
      const num = typeof provided === 'string' ? parseInt(provided, 10) : provided;
      if (!isNaN(Number(num)) && Number(num) > 0) {
        return `${num} min read.`;
      }
    }
    // Estimate from available text
    const src = (attrs.content || attrs.body || attrs.excerpt || attrs.description || '') as string;
    const words = this.stripTags(src).split(/\s+/).filter(Boolean).length;
    if (words > 0) {
      const minutes = Math.max(1, Math.ceil(words / 220));
      return `${minutes} min read.`;
    }
    return '2 min read.';
  }

  goToFeature(index: number): void {
    // Navigate to product features page and scroll to the specific feature
    this.router.navigate(['/productFeatures'], {
      fragment: `feature-${index}`
    });
  }

  isMaterialIcon(icon: string): boolean {
    return !!icon && icon.indexOf('.') === -1 && icon.indexOf('/') === -1;
  }

  toRoman(value: number): string {
    return this.romanMap[value - 1] || value.toString();
  }

}
